module.exports = __webpack_public_path__ + "img/Video-Thumbnail.jpg";